import {Component, OnInit} from '@angular/core';
import {PotStock} from '../pot';
import {MatDialogRef} from '@angular/material/dialog';
import {PotService} from '../pot.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ToastrService} from 'ngx-toastr';
import {PlantService} from '../../../plant/plant.service.tx';
import {Plant} from '../../../plant/plant';


@Component({
  selector: 'app-add-new-stock-dialog',
  templateUrl: './add-new-stock-dialog.component.html',
  styleUrls: ['./add-new-stock-dialog.component.scss']
})
export class AddNewStockDialogComponent implements OnInit {

  plantCode: string;
  bedNr: string;
  amountOfPots: number;
  amountFitForSale: number;
  unitSizeName = 'P9';
  isPlantCodeValid = false;

  constructor(
    public dialogRef: MatDialogRef<AddNewStockDialogComponent>,
    private voorraadService: PotService,
    private snackBar: MatSnackBar,
    private toastr: ToastrService,
    public plantService: PlantService) {
  }

  ngOnInit(): void {

  }

  cancel(): void {
    this.dialogRef.close();
  }

  async onSubmitClick() {
    const item: PotStock = {
      location: this.bedNr,
      plantCode: this.plantCode,
      originalAmount: this.amountOfPots,
      rest: this.amountOfPots,
      amountFitForSale: this.amountFitForSale,
      dead: 0,
      amountTrashed: 0,
      unitSizeName: this.unitSizeName,
    };
    try {
      await this.voorraadService.createStock(item).toPromise();
      this.toastr.success('Voorraad regel met plantcode ' + item.plantCode + ' opgeslagen!');
      this.dialogRef.close();
    } catch (error) {
      this.toastr.error('Er is iets fout gegaan, heb je de juiste plantcode?');
    }
  }

  isDisabled(): boolean {
    return !this.plantCode || !this.bedNr;
  }

  updatePlantCode(plantCode: string) {
    this.plantCode = plantCode;
    this.plantService.checkIfCodeIsValid(plantCode).subscribe(
      (response) => {
        this.isPlantCodeValid = response;
      },
      (error) => {
        this.toastr.error('Er is iets fout gegaan, probeer het a.u.b. opnieuw');
        console.error(error);
      }
    );
  }

  updateSelectedPlant($event: Plant) {
    this.updatePlantCode($event.code);
  }
}
